/* The moments kit (the moments plan of 2026-10-18): the shared motion of the second versions of the pages, loaded by
   snippets/cg-mo-assets.liquid on those pages only, before the page's own script (assets/cg-apps-new.js for Agent
   Apps). Built from the new homepage's engine (#57, assets/cg-home-new.js): one small animator that sleeps when idle,
   triggers that fire once when a moment comes into view, and pinned moments on native scroll (position: sticky, the
   progress read from the scroll position, never scroll-jacking). The closing lamp lives here too.
   Motion runs only while <html> has the class mo-live, set in <head> whatever the system asks for, unless the Pause
   animations button is pressed (cg-motion-off on <html>, snippets/cg-motion-toggle.liquid), the address has ?still or
   the page is in the theme editor. Without it every moment is finished and still. The button fires cg:motion on the
   document; the kit then switches in place (pause: running animations finish, triggers stop; play: what is already
   shown stays finished, motion resumes for what comes next), and a page script listening to cg:motion reads CGMO.live.
   window.CGMO is the page scripts' way in: live, anim, when, scene, tall, ease. */
(function () {
  'use strict';
  var root = document.documentElement;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  if (DESIGN) root.classList.remove('mo-live');
  var MO = window.CGMO = { live: root.classList.contains('mo-live') };

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  MO.clamp = clamp;
  MO.ease = {
    out: function (x) { return 1 - Math.pow(1 - x, 3); },
    inOut: function (x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  };
  function ramp(p, a, b) { var x = clamp((p - a) / (b - a), 0, 1); return x * x * (3 - 2 * x); }

  // ---- a small animator: one loop for everything that moves, asleep when nothing does
  var anims = [], araf = 0;
  function now() { return performance.now() / 1000; }
  function step() {
    var t = now();
    anims = anims.filter(function (a) { if (t < a.s) return true; var p = clamp((t - a.s) / a.d, 0, 1); a.f(p); return p < 1; });
    araf = anims.length ? requestAnimationFrame(step) : 0;
  }
  MO.anim = function (dur, draw, delay) { if (!MO.live) { draw(1); return; } anims.push({ s: now() + (delay || 0), d: dur, f: draw }); if (!araf) araf = requestAnimationFrame(step); };

  // ---- triggers (once, when a moment's top passes a share of the screen) and pinned moments
  // headSet: the --mo-head the page has, 68px from assets/cg-moments.css until the header is measured otherwise
  var triggers = [], scenes = [], sraf = 0, headH = 68, headSet = 68, asideT = 0, first = 0;
  MO.when = function (el, at, fn) { if (!el) return null; var g = { el: el, at: at, fn: fn, done: false }; triggers.push(g); onScroll(); return g; };
  function pageTop(el) { return el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset); }
  // A pinned moment: the section is tall, its pin is sticky under the header, and progress goes 0 to 1 while the pin
  // holds. update(p) runs only when p changes; off screen p stays 0 or 1, so nothing redraws. One made while the page
  // loads is measured with the others on the kit's first frame: measured at once, it would lay out the whole page in
  // the middle of the page script, the long task phones felt (#81).
  MO.scene = function (sec, pin, update, measure) {
    var sc = { sec: sec, pin: pin, top: 0, range: 1, last: -1, ready: false };
    sc.measure = function () { sc.top = pageTop(sec); sc.range = Math.max(1, sec.offsetHeight - pin.offsetHeight); sc.last = -1; sc.ready = true; if (measure) measure(); };
    sc.update = function (y) { if (!sc.ready) return; var p = clamp((y + headH - sc.top) / sc.range, 0, 1); if (p !== sc.last) { sc.last = p; update(p); } };
    scenes.push(sc);
    if (!first) { sc.measure(); sc.update(window.scrollY || window.pageYOffset); }
    return sc;
  };
  // where a moment fits, decided without laying the page out: the screen's height by a media query. The page scripts
  // decide with it while the page loads, then check on the next frame against the small viewport, as on every resize.
  MO.tall = function (need) { return window.matchMedia('(min-height: ' + Math.ceil(need + headH) + 'px)').matches; };
  MO.head = function () { return headH; };
  function updateAll() {
    sraf = 0;
    var y = window.scrollY || window.pageYOffset, vh = window.innerHeight;
    for (var i = 0; i < scenes.length; i++) scenes[i].update(y);
    aside();
    // and again once what the scroll set off (a category fading in) has settled
    clearTimeout(asideT); asideT = setTimeout(aside, 600);
    if (MO.live) for (var j = 0; j < triggers.length; j++) {
      var g = triggers[j];
      if (g.done) continue;
      var r = g.el.getBoundingClientRect();
      if (r.top < vh * g.at && r.bottom > vh * 0.1) { g.done = true; g.fn(); }
    }
  }
  function onScroll() { if (!sraf) sraf = requestAnimationFrame(updateAll); }
  function measureAll() {
    var hd = document.querySelector('header.top');
    headH = hd ? Math.round(hd.getBoundingClientRect().height) : 68;
    // written only when it changes: a property on <html> restyles the whole page (#81)
    if (headH !== headSet) { headSet = headH; root.style.setProperty('--mo-head', headH + 'px'); }
    scenes.forEach(function (sc) { sc.measure(); });
  }
  MO.remeasure = function () { measureAll(); updateAll(); };

  // ---- the Pause animations button steps aside (fades out, cannot be tapped) while a visible word or a control of the
  // page sits under it, so it never covers one; keyboard focus always shows it (the CSS). As on the homepage (#57).
  var toggle = document.getElementById('cg-motion-toggle'), rng = document.createRange(), CONTROLS = 'a, button, input, select, textarea, summary';
  function seen(el) {
    for (; el && el !== document.body; el = el.parentElement) if (+getComputedStyle(el).opacity < 0.05) return false;
    return true;
  }
  // does a box (x0, y0, x1, y1), as far as the ancestors that clip it let it show, touch the circle (with a margin)?
  function touches(el, b, c) {
    var x0 = b.left, y0 = b.top, x1 = b.right, y1 = b.bottom;
    for (var p = el; p && p !== document.body; p = p.parentElement) {
      var cs = getComputedStyle(p);
      if (cs.overflow === 'visible' && cs.clip === 'auto') continue;
      var q = p.getBoundingClientRect();
      x0 = Math.max(x0, q.left); y0 = Math.max(y0, q.top); x1 = Math.min(x1, q.right); y1 = Math.min(y1, q.bottom);
      if (x1 <= x0 || y1 <= y0) return false;
    }
    var nx = Math.max(x0, Math.min(c.x, x1)) - c.x, ny = Math.max(y0, Math.min(c.y, y1)) - c.y;
    return nx * nx + ny * ny < c.r * c.r;
  }
  function covers(r) {
    var c = { x: r.left + r.width / 2, y: r.top + r.height / 2, r: r.width / 2 + 4 }, roots = [];
    // the elements under the button: points across it (a 5 by 5 grid, those inside the circle)
    for (var i = 0; i <= 4; i++) for (var j = 0; j <= 4; j++) {
      var u = i / 4 - 0.5, v = j / 4 - 0.5;
      if (u * u + v * v > 0.25) continue;
      var els = document.elementsFromPoint(c.x + r.width * u, c.y + r.height * v);
      for (var k = 0; k < els.length; k++) {
        var el = els[k];
        if (el === toggle || toggle.contains(el) || el === document.body || el === document.documentElement) continue;
        if (roots.indexOf(el) < 0) roots.push(el);
        break;
      }
    }
    // then every line of words and every control inside them, against the circle itself
    for (var m = 0; m < roots.length; m++) {
      var root = roots[m], ctl = root.closest(CONTROLS);
      if (ctl && seen(ctl)) return true;
      var cs = root.querySelectorAll(CONTROLS);
      for (var n = 0; n < cs.length; n++) if (touches(cs[n], cs[n].getBoundingClientRect(), c) && seen(cs[n])) return true;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      for (var t = w.nextNode(); t; t = w.nextNode()) {
        if (!t.nodeValue.trim()) continue;
        rng.selectNodeContents(t);
        var rs = rng.getClientRects();
        for (var q = 0; q < rs.length; q++) if (touches(t.parentElement, rs[q], c) && seen(t.parentElement)) return true;
      }
    }
    return false;
  }
  function aside() {
    if (!toggle || toggle.hidden) return;
    toggle.classList.toggle('is-aside', covers(toggle.getBoundingClientRect()));
  }

  // ---- the closing lamp: a warm light gathers above the heading and settles under its glow words
  var lamps = [];
  function armLamp(l) { l.trigger = MO.when(l.sec, 0.72, function () { l.played = true; lamp(l.sec); }); }
  function lamp(sec) {
    var ball = sec.querySelector('.mo-glowball'), word = sec.querySelector('.mo-gw'), h2 = sec.querySelector('h2');
    if (!ball || !word || !h2) { if (word) word.classList.add('on'); return; }
    var r = sec.getBoundingClientRect(), w = word.getBoundingClientRect(), h = h2.getBoundingClientRect();
    var sx = r.width / 2, sy = h.top - r.top + h.height * 0.6, tx = w.left - r.left + w.width / 2, ty = w.bottom - r.top;
    MO.anim(3, function (p) {
      var a = MO.ease.out(ramp(p, 0, 0.3)), g = MO.ease.inOut(ramp(p, 0.24, 0.74)), out = ramp(p, 0.7, 0.86);
      var x = sx + (tx - sx) * g, y = sy + (ty - sy) * g, s = (1.25 - 0.25 * a) * (1 - g) + 0.03 * g;
      ball.style.opacity = (0.72 * a * (1 - out) + 0.2 * g * (1 - out)).toFixed(3);
      ball.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) scale(' + s.toFixed(3) + ')';
      if (p > 0.68 && !word.classList.contains('on')) word.classList.add('on');
    });
  }

  // ---- the Pause animations button: switch in place, before the page's own cg:motion listener runs
  function motion(on) {
    if (DESIGN || on === MO.live) return;
    MO.live = on;
    if (!on) {
      root.classList.remove('mo-live');
      anims.forEach(function (a) { a.f(1); });
      anims = [];
      triggers.forEach(function (g) { g.done = true; });
    } else {
      // what was shown finished stays finished; a lamp not reached yet waits for the visitor and plays
      var waiting = [];
      lamps.forEach(function (l) { if (!l.played && l.sec.getBoundingClientRect().top >= window.innerHeight) { waiting.push(l.sec); armLamp(l); } else l.played = true; });
      [].forEach.call(document.querySelectorAll('.mo-x, .mo-y, .mo-ok, .mo-gw'), function (el) {
        if (!waiting.some(function (sec) { return sec.contains(el) && el.classList.contains('mo-gw'); })) el.classList.add('on');
      });
      root.classList.add('mo-live');
    }
    // measured next frame, after the page's own cg:motion listener, so nothing it shows finished fades in again
    requestAnimationFrame(MO.remeasure);
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('.mo-lamp'), function (sec) { var l = { sec: sec, played: false }; lamps.push(l); if (MO.live) armLamp(l); });
    document.addEventListener('cg:motion', function (e) { motion(!(e.detail && e.detail.off)); });
    addEventListener('scroll', onScroll, { passive: true });
    var rt = 0;
    function re() { cancelAnimationFrame(rt); rt = requestAnimationFrame(function () { rt = 0; first = 0; MO.remeasure(); }); }
    addEventListener('resize', re);
    if ('ResizeObserver' in window) new ResizeObserver(re).observe(document.body);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(re);
    first = 1;
    re();
  }
  boot();
})();
